import { render, staticRenderFns } from "./UsuarioFornecedorList.vue?vue&type=template&id=032a3662&lang=html"
import script from "./UsuarioFornecedorList.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports